// removed by extract-text-webpack-plugin
module.exports = {"component":"_23zM-6wl9Aiat23iaswP0r"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopCommission/ExperienceShopCommission.scss
 ** module id = 1059
 ** module chunks = 0
 **/